import {
  Team,
  CreateTeamDto,
  UpdateTeamDto,
  User,
} from '@risk-management/shared';
import { apiService } from './api.service';

export interface TeamWithMembers extends Team {
  members: User[];
  userTeams?: { id: string; userId: string; teamId: string; joinedAt: Date }[];
}

export const teamsService = {
  getAll: () => apiService.get<Team[]>('/teams'),

  getById: (id: string) => apiService.get<Team>(`/teams/${id}`),

  getWithMembers: (id: string) =>
    apiService.get<TeamWithMembers>(`/teams/${id}/with-members`),

  create: (data: CreateTeamDto) => apiService.post<Team>('/teams', data),

  update: (id: string, data: UpdateTeamDto) =>
    apiService.patch<Team>(`/teams/${id}`, data),

  delete: (id: string) => apiService.delete<void>(`/teams/${id}`),

  // Member management
  getMembers: (teamId: string) =>
    apiService.get<User[]>(`/teams/${teamId}/members`),

  addMember: (teamId: string, userId: string) =>
    apiService.post<void>(`/teams/${teamId}/members/${userId}`, {}),

  removeMember: (teamId: string, userId: string) =>
    apiService.delete<void>(`/teams/${teamId}/members/${userId}`),
};
